export enum StageType {
  REGULAR = 'regular',
  LOST = 'lost',
  NURTURING = 'nurturing',
}
